export enum EmployeeType {
  Manager = 'manager',
  Agent = 'agent',
}
